import React from 'react';
import './index.scss';
import { currentShiftSwitchModeItems } from '../../../utils/constants';
import i18n from 'i18next';
import { useHistory, useLocation } from 'react-router';
import classNames from 'classnames';

const CurrentShiftSwitchMode = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const handleChangeMode = modeLink => {
    history.push(modeLink);
  };

  return (
    <div className={'currentShiftSwitchModeWrapper'}>
      {currentShiftSwitchModeItems.map(mode => (
        <div
          className={classNames('switch-button', { active: mode.link === pathname })}
          key={mode.link}
          onClick={() => handleChangeMode(mode.link)}
        >
          {i18n.t(mode.title)}
        </div>
      ))}
    </div>
  );
};

export default CurrentShiftSwitchMode;
